/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/v1/authz/check/resources": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Evaluates whether some specific actions can be performed by current user */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Cookie */
                    Cookie?: string;
                };
                path?: never;
                cookie?: never;
            };
            /** @description Check rules request */
            requestBody: {
                content: {
                    "application/json": components["schemas"]["dto.CheckRulesDTO"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["app.CheckPoliciesResponseDTO"];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/authz/office/policies/native": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieves the list of native policies */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["entity.NativePolicy"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/authz/policies/native": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieves the list of native policies */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        "application/json": components["schemas"]["entity.NativePolicy"][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        "app.ActionCheckResult": {
            action: components["schemas"]["constants.RuleAction"];
            can?: boolean;
            effect: components["schemas"]["constants.PolicyEffect"];
            scope?: components["schemas"]["constants.PolicyScope"];
        };
        "app.ActionResult": {
            [key: string]: components["schemas"]["app.ActionCheckResult"];
        };
        "app.CheckPoliciesResponseDTO": {
            result?: components["schemas"]["app.CheckResult"];
        };
        "app.CheckResult": {
            [key: string]: components["schemas"]["app.ActionResult"];
        };
        /** @enum {string} */
        "constants.BuiltinRole": "owner" | "admin" | "developer" | "manager" | "external" | "view" | "analyst" | "member";
        /** @enum {string} */
        "constants.PolicyEffect": "EFFECT_ALLOW" | "EFFECT_DENY";
        /** @enum {string} */
        "constants.PolicyResource": "inference" | "message-template" | "inspection" | "company" | "membership" | "guest" | "webhook" | "oauth" | "invoice" | "subscription" | "stats" | "team" | "rules" | "template" | "theme" | "signature" | "secrets" | "docs";
        /** @enum {string} */
        "constants.PolicyScope": "team" | "all" | "own";
        /** @enum {string} */
        "constants.RuleAction": "read" | "create" | "update" | "delete";
        "dto.CheckRulesDTO": {
            resources: components["schemas"]["dto.ResourceQuery"][];
        };
        "dto.ResourceQuery": {
            actions?: components["schemas"]["constants.RuleAction"][];
            kind: components["schemas"]["constants.PolicyResource"];
        };
        "entity.NativePolicy": {
            definition: components["schemas"]["entity.NativePolicyDefinition"];
            name: components["schemas"]["constants.BuiltinRole"];
            native?: boolean;
        };
        "entity.NativePolicyDefinition": {
            rules: components["schemas"]["entity.PolicyDefinitionRule"][];
        };
        "entity.PolicyDefinitionRule": {
            actions: components["schemas"]["entity.PolicyDefinitionRuleAction"][];
            /** @description TODO: Here instead of use literal oneof we can create a custom validation consuming data.resources and data.actions. This is better in terms of mantenability */
            resource: components["schemas"]["constants.PolicyResource"];
        };
        "entity.PolicyDefinitionRuleAction": {
            action: components["schemas"]["constants.RuleAction"];
            effect: components["schemas"]["constants.PolicyEffect"];
            scope?: components["schemas"]["constants.PolicyScope"];
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
type ReadonlyArray<T> = [
    Exclude<T, undefined>
] extends [
    any[]
] ? Readonly<Exclude<T, undefined>> : Readonly<Exclude<T, undefined>[]>;
export const constantsBuiltinRoleValues: ReadonlyArray<components["schemas"]["constants.BuiltinRole"]> = ["owner", "admin", "developer", "manager", "external", "view", "analyst", "member"];
export const constantsPolicyEffectValues: ReadonlyArray<components["schemas"]["constants.PolicyEffect"]> = ["EFFECT_ALLOW", "EFFECT_DENY"];
export const constantsPolicyResourceValues: ReadonlyArray<components["schemas"]["constants.PolicyResource"]> = ["inference", "message-template", "inspection", "company", "membership", "guest", "webhook", "oauth", "invoice", "subscription", "stats", "team", "rules", "template", "theme", "signature", "secrets", "docs"];
export const constantsPolicyScopeValues: ReadonlyArray<components["schemas"]["constants.PolicyScope"]> = ["team", "all", "own"];
export const constantsRuleActionValues: ReadonlyArray<components["schemas"]["constants.RuleAction"]> = ["read", "create", "update", "delete"];
export type operations = Record<string, never>;
